/* RESPONSIBLE TEAM: team-knowledge-foundations */
import { attr } from '@ember-data/model';
import Fragment from 'ember-data-model-fragments/fragment';

export default class ArticleGroupContent extends Fragment {
  @attr declare localeId: string;
  @attr declare name: string;
  @attr declare description: string;
}
